











import { Vue, Component, Prop } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import RootCauseCategoryModel from '@/models/investigation/rootCauseCategoryModel'
import RootCauseModel from '@/models/investigation/rootCauseModel'
import RootCauseList from '@/components/lists/RootCauseList.vue'
import LoadingIndicator from '@/components/loading/LoadingIndicator.vue'

@Component({
  components: {
    RootCauseList,
    LoadingIndicator
  }
})
export default class RootCauses extends Vue {
  @Prop(String) readonly id!: string

  private rootCauseCategories: Array<RootCauseCategoryModel> = []
  private loading: boolean = true
  private listDisabled = false

  private async created() {
    await this.getRootCauses()
  }

  private async getRootCauses(): Promise<void> {
    this.listDisabled = true

    try {
      this.rootCauseCategories = await ApiService.getAllById<
        RootCauseCategoryModel
      >(UrlType.RootCause, this.id + `?nocache=${new Date().getTime()}`)
    } finally {
      this.loading = false
      this.listDisabled = false
    }
  }
}
